
if (!customElements.get('categories-tabs')) {
  class CategoriesTabs extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};

      // Mark the first tab as active by default
      this.querySelectorAll('.swiper-slide')[0].classList.add('category-active-tab');
    }

    // Method to bind events to the component
    bindEvents() {
      this.addEventListener('click', (e) => {
        const targetEl = e.target.dataset.categoryKey; // Get the category key from the clicked element
        if (targetEl) {
          // Remove the active state from all sibling tabs
          const allSliderSiblings = e.target.closest('ul').querySelectorAll('.swiper-slide');
          allSliderSiblings.forEach((el) => el.classList.remove('category-active-tab'));

          // Add the active state to the clicked tab
          e.target.classList.add('category-active-tab');

          // Display the corresponding tab content
          const targetTabContent = document.getElementById(targetEl); // Find the content for the clicked tab
          const allTabContentSiblings = targetTabContent.closest('.categories-scroll__tabs-content').querySelectorAll('.tab__content');

          // Hide all other tab contents
          allTabContentSiblings.forEach((el) => (el.classList.remove('tab-content__visible')));

          // Show the selected tab content
          targetTabContent.classList.add('tab-content__visible')
        }
      });
    }

    // Method to initialize the Swiper slider if present
    initSlider() {
      if (!this.querySelector('[data-slider]')) return; // Exit if no slider element is found

      // Configure Swiper options
      this.options = {
        slidesPerView: 'auto', // Show as many slides as fit within the container
        loop: true, // Enable infinite scrolling by looping the slides
        centeredSlides: true, // Center the active slide
        breakpoints: {
          1024: {
            loop: false, // Disable looping on devices with width >= 1024px
            centeredSlides: false, // Disable centering on devices with width >= 1024px
          }
        }
      };

      // Initialize the Swiper slider
      this.slider = new Swiper(
        this.querySelector('[data-slider]'), // Pass the slider element
        this.options, // Pass the configuration options
      );
    }

    connectedCallback() {
      // this.initSlider(); // Initialize the slider if applicable
      this.bindEvents(); // Attach event listeners
    }
  }

  customElements.define('categories-tabs', CategoriesTabs);
}

if (!customElements.get('categories-content-swiper')) {
  class CategoriesContentSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.parent = this.closest('.categories-scroll__tabs-content')

      // Mark the first tab as active by default
      this.parent?.querySelectorAll('.tab__content')[0].classList.add('tab-content__visible');
    }

    // Method to initialize the Swiper slider if present
    initSlider() {
      if (!this.querySelector('[data-slider]')) return; // Exit if no slider element is found

      const totalSlides = this.querySelectorAll('.swiper-slide');
      // Configure Swiper options
      this.options = {
        slidesPerView: 1.8, // Show as many slides as fit within the container
        loop: true, // Enable infinite scrolling by looping the slides,
        spaceBetween: 5,
        centeredSlides: true, // Center the active slide
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        breakpoints: {
          750: {
            slidesPerView: 2.2
          },
          1024: {
            slidesPerView: 3.8
          }
        }
      };

      // Initialize the Swiper slider
      this.slider = new Swiper(
        this.querySelector('[data-slider]'), // Pass the slider element
        this.options, // Pass the configuration options
      );
    }

    connectedCallback() {
      this.initSlider(); // Initialize the slider if applicable
    }
  }
  customElements.define('categories-content-swiper', CategoriesContentSwiper);
}